import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import {
    fetchSiteMapRegionAggregationListActionTypes,
    fetchSiteMapRegionCityListActionTypes,
    fetchSiteMapRegionCountyListActionTypes,
    fetchSiteMapRegionVoivodeshipListActionTypes,
    ISitemapRegionListRegion,
    ISitemapRegionListRegionShort
} from "../actions/fetch_site_map_region";

export interface ISitemapRegionsStore {
    voivodeship: ISitemapRegionListRegion[] | ISitemapRegionListRegionShort[] | null;
    aggregation: ISitemapRegionListRegion[] | null;
    county: ISitemapRegionListRegion[] | null;
    city: ISitemapRegionListRegion[] | null;
}

export const siteMapRegionsReducer = combineReducers({
    voivodeship: reduceResponse<ISitemapRegionListRegion[] | ISitemapRegionListRegionShort[]>(fetchSiteMapRegionVoivodeshipListActionTypes),
    aggregation: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionAggregationListActionTypes),
    county: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionCountyListActionTypes),
    city: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionCityListActionTypes)
});
import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import {
    fetchSiteMapRegionAggregationListActionTypes,
    fetchSiteMapRegionCityListActionTypes,
    fetchSiteMapRegionCountyListActionTypes,
    fetchSiteMapRegionVoivodeshipListActionTypes,
    ISitemapRegionListRegion,
    ISitemapRegionListRegionShort
} from "../actions/fetch_site_map_region";

export interface ISitemapRegionsStore {
    voivodeship: ISitemapRegionListRegion[] | ISitemapRegionListRegionShort[] | null;
    aggregation: ISitemapRegionListRegion[] | null;
    county: ISitemapRegionListRegion[] | null;
    city: ISitemapRegionListRegion[] | null;
}

export const siteMapRegionsReducer = combineReducers({
    voivodeship: reduceResponse<ISitemapRegionListRegion[] | ISitemapRegionListRegionShort[]>(fetchSiteMapRegionVoivodeshipListActionTypes),
    aggregation: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionAggregationListActionTypes),
    county: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionCountyListActionTypes),
    city: reduceResponse<ISitemapRegionListRegion[]>(fetchSiteMapRegionCityListActionTypes)
});
